import React, {Component} from "react";
import * as api from "../../api/config";
import {Card, Spin, Form, message, Switch, Button, Select, Input, InputNumber} from "antd";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import Styles from "./index.module.css"
import fields from './fields'

class CompanyConfig extends Component {


    state = {
        loading: false,
        configs: [],
        saving: false
    }

    formLayout = {
        labelCol: {
            span: 12
        },
        wrapperCol: {
            span: 12
        },
    }

    tailFormLayout = {
        wrapperCol: {
            span: 2,
            offset: 11,
        }
    }

    componentDidMount() {
        this.setState({loading: true})
        api.getConfigs().then(({data}) => {
            const configs = data.data.map(item => {
                if (item.type === 'array') {
                    item.value = item.value.split(',')
                }
                return item
            })
            this.setState({
                loading: false,
                configs: configs
            })
        }).catch(() => {
            this.setState({
                loading: false,
            })
        })
    }

    onSubmit = (event) => {
        event.preventDefault()
        this.props.form.validateFieldsAndScroll((errors, values) => {
            this.setState({saving: true})
            api.setConfigs(values).then(() => {
                this.setState({saving: false})
                message.success("设置成功")
            }).catch(() => {
                this.setState({saving: false})
            })
        })
    }

    render() {
        const configs = this.state.configs
        const {getFieldDecorator} = this.props.form
        const formItems = configs.map(item => (
            <Form.Item key={item.name} label={item.description}>
                {item.type === 'bool' ? (
                    getFieldDecorator(item.name, {
                        initialValue: item.value,
                        rules: [{required: true}],
                        valuePropName: 'checked'
                    })(
                        <Switch/>
                    )
                ) : (
                    item.type === 'number' ? (
                        getFieldDecorator(item.name, {
                            initialValue: item.value,
                            rules: [{required: true}],
                        })(
                            <InputNumber/>
                        )
                    ) : item.type === 'array' ? (
                        (
                            getFieldDecorator(item.name, {
                                initialValue: item.value,
                                rules: [{required: true}],
                            })(
                                <Select mode={"multiple"}>
                                    {fields.map(item => (
                                        <Select.Option value={item.value}>{item.name}</Select.Option>
                                    ))}
                                </Select>
                            )
                        )
                    ) : (
                        getFieldDecorator(item.name, {
                            initialValue: item.value,
                            rules: [{required: true}],
                        })(
                            <Input/>
                        )
                    )
                )}
            </Form.Item>
        ))
        return (
            <PageHeaderLayout title={'参数设置'}>
                <Card>
                    {this.state.loading ? (
                        <div className={Styles.loadingContainer}>
                            <Spin/>
                        </div>
                    ) : (
                        <div>
                            <Form {...this.formLayout} onSubmit={this.onSubmit}>
                                {formItems}
                                <Form.Item {...this.tailFormLayout}>
                                    <Button loading={this.state.saving} type="primary" htmlType="submit">
                                        提交
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    )}
                </Card>
            </PageHeaderLayout>
        );
    }
}

export default Form.create()(CompanyConfig)